export default __webpack_public_path__ + "static/media/list_main_11_1.6fab253c.png";